module.exports = __webpack_public_path__ + "media/images/icons/unchecked-ed10909ef4a44b7cdac0062cd628fae9.svg";